import React from 'react'
import PropTypes from 'prop-types'
import {Alert, Box, Divider, Flex} from '@chakra-ui/react'
import ProductSetCockpitTotal from './product-set-cockpit-total'
import CustomizablePsdpSetProductTile from './customizable-psdp-set-product-tile'
import AddToCartCTA, {Skeleton as AddToCartCTASkeleton} from '../../../components/add-to-cart-cta'
import CockpitOrderSection from './cockpit-order-section'

/**
 * Render the right column of the customizable product set detail page
 */
const CustomizablePsdpCockpitRightColumn = ({
    configureRef,
    isPromotionsLoading,
    isVariantLoading,
    product,
    promotions,
    rightSidebarSizeProps,
    stickyProps,
    onAddToCartClick,
    onRecommendedProductClick
}) => {
    return (
        <Flex
            flexDirection="column"
            gap={{base: 0, lg: 6}}
            data-testid={'product-set-cockpit-right-column'}
            scrollMarginTop={24}
            {...stickyProps}
            {...rightSidebarSizeProps}
            ref={configureRef}
        >
            <Flex
                flexDirection="column"
                gap={{base: 6, lg: 4, xl: 6}}
                paddingBlock={{base: 4, lg: 0}}
                paddingInline={{base: 4, lg: 0}}
                sx={{
                    '.swatch-group-list': {
                        marginInline: {base: -4, lg: 0},
                        paddingInline: {base: 4, lg: 0}
                    }
                }}
            >
                {/* Total price */}
                <Box
                    display={{base: 'none', lg: 'block'}}
                    paddingBottom={2.5}
                    borderBottom="1px"
                    borderColor="stokkeGray.dark"
                >
                    <ProductSetCockpitTotal product={product} />
                </Box>

                {/* List the setProducts - actually only their material and color variant selectors */}
                {product.setProducts.map((setProduct, index) => (
                    <CustomizablePsdpSetProductTile
                        key={setProduct.id + '_' + index}
                        index={index}
                        product={setProduct}
                    />
                ))}
            </Flex>
            {/* The two accordions with extensions and accessories products */}
            <Box paddingInline={{base: 4, lg: 0}} paddingBlockStart={{base: 2, lg: 0}}>
                <Flex flexDirection="column" gap={6} paddingBlock={{lg: 6}}>
                    <Divider borderColor="stokkeGray.dark" />
                    <Alert status="error" variant="solid">
                        01 Choose your individual set
                    </Alert>
                    <Divider borderColor="stokkeGray.dark" />
                </Flex>
                <Flex flexDirection="column" gap={6} height={{base: '112px', lg: 'auto'}}>
                    <Divider borderColor={{base: 'stokkeGray.dark', lg: 'transparent'}} />
                    <Alert status="error" variant="solid">
                        02 Choose your accessories
                    </Alert>
                    <Divider borderColor="stokkeGray.dark" />
                </Flex>
            </Box>

            <Flex flexDirection="column" gap={4} paddingInline={{base: 4, lg: 0}}>
                {/* Another total price */}
                <ProductSetCockpitTotal product={product} />

                {/* Add to cart CTA */}
                <Flex flexDirection="column" gap={2}>
                    {!isVariantLoading ? (
                        <AddToCartCTA
                            isPromotionsLoading={isPromotionsLoading}
                            isVariantLoading={isVariantLoading}
                            product={product}
                            promotions={promotions}
                            onClick={onAddToCartClick}
                            onRecommendedProductClick={onRecommendedProductClick}
                        />
                    ) : (
                        <AddToCartCTASkeleton />
                    )}
                </Flex>

                {/* Rest of order section */}
                <CockpitOrderSection
                    product={product}
                    promotions={promotions}
                    isPromotionsLoading={isPromotionsLoading}
                    isProductASet
                    isVariantLoading={isVariantLoading}
                    onAddToCartClick={onAddToCartClick}
                />
            </Flex>
        </Flex>
    )
}

CustomizablePsdpCockpitRightColumn.propTypes = {
    configureRef: PropTypes.object,
    isPromotionsLoading: PropTypes.bool,
    isVariantLoading: PropTypes.bool,
    product: PropTypes.object,
    promotions: PropTypes.array,
    rightSidebarSizeProps: PropTypes.object,
    stickyProps: PropTypes.object,
    onAddToCartClick: PropTypes.func,
    onRecommendedProductClick: PropTypes.func
}

export default CustomizablePsdpCockpitRightColumn
